import 'react-native-gesture-handler'
import 'src/helpers/image'
import 'src/resources/locale/locale'

import React from 'react'
import { Text, AppRegistry, Platform, LogBox } from 'react-native'
import Bugsnag from '@bugsnag/react-native'
import { NavigationContainer } from '@react-navigation/native'
import { StoreProvider } from 'easy-peasy'
import { parse } from 'search-params'
import { SafeAreaProvider } from 'react-native-safe-area-context'

import * as UI from 'native-base'

import { Store } from 'src/state'
import { theme } from 'src/theme'

import { Router } from 'src/layout/router'
import { withLayout } from 'src/layout/layout'
import { setBackgroundMessageHandler } from 'src/helpers/messaging'

// Limit font scaling to +15% max, otherwise the design
// does not scale correctly
// @ts-ignore
Text.defaultProps = {
  maxFontSizeMultiplier: 1.15,
}

setBackgroundMessageHandler(() => {
  return Promise.resolve()
})

Bugsnag.start({
  onError: (event) => {
    event.setUser(Store.getState().utils.session.claims._id)
  },
})
const ErrorBoundary = Bugsnag.getPlugin('react')!.createErrorBoundary(React)

const ErrorView = withLayout(() => null, {
  theme: 'day',
  topBar: false,
  tabBar: false,
})

// Plus de synchronisation CodePush au démarrage : App Center est fermé depuis le
// 31 mars 2025 et aucun serveur de remplacement n'est configuré. Le module natif
// reste en place, il sert le bundle embarqué.
const App = () => (
  <NavigationContainer
    linking={{
      prefixes: [
        'https://app.napandup.com',
        'https://app.staging.napandup.com',
      ],
      getStateFromPath(path) {
        const [location, search = ''] = path.split('?')
        const name = `/${location
          .replace(/-/g, '/')
          .split('/')
          .filter((p) => !!p)
          .join('/')}`
        const params = parse(search)

        return {
          routes: [
            {
              name,
              params,
            },
          ],
        }
      },
      getPathFromState(state) {
        return state.routes[state.index ?? 0].name
      },
    }}
  >
    <SafeAreaProvider>
      <StoreProvider store={Store}>
        <UI.NativeBaseProvider theme={theme}>
          <ErrorBoundary FallbackComponent={() => <ErrorView />}>
            <Router />
          </ErrorBoundary>
        </UI.NativeBaseProvider>
      </StoreProvider>
    </SafeAreaProvider>
  </NavigationContainer>
)

AppRegistry.registerComponent('napandup', () => App)

if (Platform.OS === 'web') {
  AppRegistry.runApplication('napandup', {
    rootTag: document.getElementById('react-root'),
  })
}

LogBox.ignoreLogs([
  'When server rendering, you must wrap your application',
  'Require cycle: node_modules/react-native/Libraries',
])
